import { useState } from 'react';
import { IoArrowBack, IoClose, IoMenu } from 'react-icons/io5';
import Logo from '../../../Asset/images/logo-transparent.png';
import { useLocation, useNavigate } from 'react-router-dom';
import GoodTimesFontText from '@/TRC/components/goodTimesFontText';
import Search from './search';
import { buildRoutes } from '@/service/buildRoutes';
import { useAtomValue } from 'jotai';
import { accessStatusAtom } from '@/TRC/atoms/trc-global';
import ACCESS_STATUS from '@/TRC/constants/accessStatus';
import { TRC_NAVBAR_VALUES } from '@/TRC/constants/trcNavBarValues';
import { TRC_ROUTES } from '@/TRC/constants/trcRoutes';
import { userInfoAtom } from '@/data/atoms/utilsAtoms';
import { getStudioHubBasePath, shouldShowStudioHub } from '@/utils/isStudioUser';

const TRCHeader = () => {
	const [isNavOpen, setIsNavOpen] = useState(false);
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const userStatusAccess = useAtomValue(accessStatusAtom);
	const userData = useAtomValue(userInfoAtom);
	const isStudioHub = shouldShowStudioHub(userData);
	const basePath = getStudioHubBasePath(userData);
	const hasNoAccess = !userStatusAccess || userStatusAccess === ACCESS_STATUS.NO_ACCESS;
	const textColor = hasNoAccess ? '#8E8E8E' : '#fff';

	const trcUrls = [
		{
			label: TRC_NAVBAR_VALUES.LESSON_PLANS,
			url: buildRoutes.toTRCLessonPlans(basePath)
		},
		{
			label: TRC_NAVBAR_VALUES.VIDEOS,
			url: buildRoutes.toTRCVideos(basePath)
		},
		{
			label: TRC_NAVBAR_VALUES.RESOURCES,
			url: buildRoutes.toTRCResources(basePath)
		},
		{
			label: TRC_NAVBAR_VALUES.VIEW_ALL,
			url: buildRoutes.toTRCViewAll(basePath)
		}
	];

	return (
		<header className="position-relative text-white bg-dark">
			<div className="w-100 pe-1">
				<div className="d-flex justify-content-between align-items-center gap-2 gap-xl-0">
					<div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
						<div
							className="d-flex align-items-center gap-1 m-0 ps-1 ps-xl-3 pe-1 cursor-pointer"
							style={{ backgroundColor: '#171718' }}
							onClick={() => navigate(buildRoutes.toMainHome())}
						>
							<button className="btn btn-link text-white p-0">
								<IoArrowBack size={20} />
							</button>
							<img src={Logo} alt="avatarImg" height="60" width="60" />
						</div>
						<div className="cursor-pointer" onClick={() => navigate(buildRoutes.toTRCHome(basePath))}>
							<GoodTimesFontText fontSize="clamp(1rem, 1.2vw, 1.6rem)" styles={{ paddingTop: '0.5rem' }}>
								{isStudioHub ? 'STUDIO HUB' : 'TEACHER RESOURCE CENTER'}
							</GoodTimesFontText>
						</div>
					</div>

					<div className="d-flex justify-content-end align-items-center flex-grow-1 min-w-0">
						<nav className="d-none d-xl-flex me-1 flex-grow-1 justify-content-end" style={{ paddingTop: '0.5rem' }}>
							<ul className="nav flex-nowrap align-items-center">
								{trcUrls.map((item, index) => (
									<li key={index} className="nav-item">
										<a href={item.url} className="nav-link text-light px-1 text-nowrap">
											<GoodTimesFontText
												color={textColor}
												fontSize="clamp(0.55rem, 0.9vw, 0.95rem)"
												styles={{ fontWeight: pathname === item.url ? '700' : '300' }}
												showUnderline={pathname === item.url}
											>
												{item.label}
											</GoodTimesFontText>
										</a>
									</li>
								))}
							</ul>
						</nav>

						<Search placeholder={isStudioHub ? 'Search Studio Hub' : 'Search TRC'} basePath={basePath} />

						<button className="btn btn-link d-xl-none p-0 text-white" onClick={() => setIsNavOpen(!isNavOpen)}>
							{isNavOpen ? <IoClose size={30} /> : <IoMenu size={30} />}
						</button>
					</div>
				</div>

				<div className={`row mt-3 d-xl-none ${isNavOpen ? '' : 'd-none'}`}>
					<div className="col-12">
						<nav>
							<ul className="nav flex-column">
								{trcUrls.map((item, index) => (
									<li key={index} className="nav-item">
										<a href={item.url} className="nav-link text-light py-2">
											<GoodTimesFontText color="#8E8E8E">{item.label}</GoodTimesFontText>
										</a>
									</li>
								))}
							</ul>
						</nav>
					</div>
				</div>
			</div>
		</header>
	);
};

export default TRCHeader;
